// src/config/api.js

const API_CONFIG = {
    // 开发环境 API 地址
    development: {
        // baseUrl: 'https://erxi.mepay.club/prod-api',
        // baseUrl: 'https://h5.parttime.mobi/prod-api',
        baseUrl: 'http://localhost:8083',
        // baseUrl: 'http://52.221.4.74:90/prod-api',
    },
    // 测试环境 API 地址
    testing: {
        baseUrl: 'http://52.221.4.74:90/prod-api',
    },
    // 生产环境 API 地址
    production: {
        // baseUrl: 'https://erxi.mepay.club/prod-api',
        baseUrl: '/prod-api',
        // baseUrl: 'http://52.221.4.74:90/prod-api',
    },
}

// 根据当前环境选择对应的 API 地址
const currentEnv = process.env.NODE_ENV

let currentConfig
if (currentEnv === 'development') {
    currentConfig = API_CONFIG.development
} else if (currentEnv === 'testing') {
    currentConfig = API_CONFIG.testing
} else {
    currentConfig = API_CONFIG.production
}

export default currentConfig
